/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoModelsBoolResponse
 */
export interface FusionMelcoModelsBoolResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FusionMelcoModelsBoolResponse
     */
    result?: boolean;
}

export function FusionMelcoModelsBoolResponseFromJSON(json: any): FusionMelcoModelsBoolResponse {
    return FusionMelcoModelsBoolResponseFromJSONTyped(json, false);
}

export function FusionMelcoModelsBoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoModelsBoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function FusionMelcoModelsBoolResponseToJSON(value?: FusionMelcoModelsBoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}


